import { CriterionRoute } from '@/router/Evaluation/CriterionRoute';

export const EvaluationPerformanceGoalFile = {
    path: '/evaluation_performance_goal_files',
    name: 'evaluation_performance_goal_files',
    component: () => import('@/views/Evaluation/File/EvaluationPerformanceGoalFilePage.vue'),
    children: [
        {
            path: '/evaluation_performance_goal_files/add',
            name: 'evaluation_performance_goal_files.add',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                addAction: true,
                type: 'EVALUATION_PERFORMANCE',
            },
            children: [
                ...CriterionRoute('evaluation_performance_goal_files.add',
                    'EVALUATION_PERFORMANCE_CRITERION_CATEGORY',
                    'EVALUATION_PERFORMANCE')
            ]
        },
        {
            path: '/evaluation_performance_goal_file_indices/add',
            name: 'evaluation_performance_goal_file_indices.add',
            component: () => import('@/views/Evaluation/FileIndex/Form/EvaluationFileIndexForm.vue'),
            props: {addAction: true, type: 'EVALUATION_PERFORMANCE',},
        },
        {
            path: '/evaluation_performance_goal_files/edit/:id',
            name: 'evaluation_performance_goal_files.edit',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                updateAction: true,
                type: 'EVALUATION_PERFORMANCE',
            },
            children: [
                ...CriterionRoute('evaluation_performance_goal_files.edit',
                    'EVALUATION_PERFORMANCE_CRITERION_CATEGORY',
                    'EVALUATION_PERFORMANCE')
            ]
        },
        {
            path: '/evaluation_performance_goal_files/duplicate/:id',
            name: 'evaluation_performance_goal_files.duplicate',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                duplicateAction: true,
                type: 'EVALUATION_PERFORMANCE',
            },
            children: [
                ...CriterionRoute('evaluation_performance_goal_files.duplicate',
                    'EVALUATION_PERFORMANCE_CRITERION_CATEGORY',
                    'EVALUATION_PERFORMANCE')
            ]
        },
        {
            path: '/evaluation_performance_goal_files/bulk_update',
            name: 'evaluation_performance_goal_files.bulk_update',
            component: () => import('@/views/Evaluation/File/Form/BulkUpdateForm.vue'),
            props: {
                duplicateAction: true,
                type: 'EVALUATION_PERFORMANCE',
            },
            children: [
                ...CriterionRoute('evaluation_performance_goal_files.bulk_update',
                    'EVALUATION_PERFORMANCE_CRITERION_CATEGORY',
                    'EVALUATION_PERFORMANCE')
            ]
        },
        {
            path: '/evaluation_performance_goal_files/delete/:id',
            name: 'evaluation_performance_goal_files.delete',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                deleteAction: true,
                type: 'EVALUATION_PERFORMANCE',
            }
        },
        {
            path: '/evaluation_performance_goal_files/view/:id',
            name: 'evaluation_performance_goal_files.view',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                viewAction: true,
                type: 'EVALUATION_PERFORMANCE',
            }
        },
        {
            path: '/evaluation_performance_goal_files/archive/:id',
            name: 'evaluation_performance_goal_files.archive',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                archiveAction: true,
                type: 'EVALUATION_PERFORMANCE',
            }
        },
        {
            path: '/evaluation_performance_goal_files/unarchive/:id',
            name: 'evaluation_performance_goal_files.unarchive',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                unarchiveAction: true,
                type: 'EVALUATION_PERFORMANCE',
            }
        },
    ]
}